import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useMapStore } from '../../store/mapStore';
import { FilterType } from '../../types';

const filters: { value: FilterType; label: string }[] = [
  { value: 'all', label: 'All Locations' },
  { value: 'departure', label: 'Departure from Troy' },
  { value: 'wanderings', label: 'The Wanderings' },
  { value: 'return', label: 'Return to Ithaca' },
  { value: 'telemachus', label: "Telemachus's Journey" },
  { value: 'filming', label: "Nolan's Filming Locations" },
];

const JourneyFilter = () => {
  const { activeFilter, setActiveFilter, isJourneyPlaying, playJourney, pauseJourney } = useMapStore();
  const [isExpanded, setIsExpanded] = useState(true);

  const handlePlayPause = () => {
    if (isJourneyPlaying) {
      pauseJourney();
    } else {
      playJourney();
    }
  };

  return (
    <div className="absolute top-4 left-4 z-[1000]">
      {/* Toggle Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="bg-copper text-parchment-base p-3 rounded-lg shadow-lg hover:bg-gold transition-all border-2 border-ink-primary mb-2"
        aria-label="Toggle journey filter"
      >
        <span className="text-xl">
          {isExpanded ? '◀' : '▶'}
        </span>
      </button>

      {/* Expandable Panel */}
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
            className="bg-parchment-base border-2 border-copper rounded-lg p-4 shadow-lg max-w-xs"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display text-xl text-ink-primary">Journey Filter</h3>

              {/* Play/Pause Journey Button */}
              <button
                onClick={handlePlayPause}
                className={`px-4 py-2 rounded-lg font-ui font-bold transition-all shadow-lg ${
                  isJourneyPlaying
                    ? 'bg-ink-primary text-gold hover:bg-ink-secondary'
                    : 'bg-gold text-ink-primary hover:bg-copper hover:text-parchment-base'
                }`}
                aria-label={isJourneyPlaying ? 'Pause journey' : 'Play journey'}
              >
                {isJourneyPlaying ? '⏸ Pause' : '▶ Play Journey'}
              </button>
            </div>
            <div className="space-y-2">
              {filters.map((filter) => (
                <button
                  key={filter.value}
                  onClick={() => setActiveFilter(filter.value)}
                  className={`w-full text-left px-3 py-2 rounded font-ui transition-all ${
                    activeFilter === filter.value
                      ? 'bg-gold text-ink-primary shadow-marker-glow'
                      : 'bg-parchment-dark text-ink-secondary hover:bg-copper hover:text-parchment-base'
                  }`}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default JourneyFilter;
